// Privacy-safe pricing analytics. Only allow-listed event names + non-sensitive
// props (plan_id, source) are sent. NEVER document contents or verification data.
import api from "@/lib/api";

const ALLOWED = new Set([
  "pricing_view",
  "plan_finder_started",
  "plan_finder_completed",
  "plan_recommended",
  "compare_plans_opened",
  "plan_selected",
  "checkout_started",
  "subscription_active",
]);

export function track(event, props = {}) {
  if (!ALLOWED.has(event)) return;
  const payload = { event };
  if (props.plan_id) payload.plan_id = String(props.plan_id).slice(0, 24);
  if (props.source) payload.source = String(props.source).slice(0, 24);
  // fire-and-forget; analytics must never block or break the UI
  try {
    api.post("/analytics/event", payload).catch(() => {});
  } catch (_) { /* noop */ }
}
